<template>
    <v-data-table
        v-if="shows"
        v-bind="{
            items,
            headers,
            itemsPerPage: -1,
            mobileBreakpoint: 9999,
        }"
        hide-default-footer
        disable-pagination
        disable-sort
        class="nshop-order-view-table"
    >
        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :class="header.class" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { initDataTableHeaders } from "@/assets/lib";
import { initNshopOrder, NSHOP_ORDER_PAYMENT_METHODS, NSHOP_ORDER_STATES } from "@/store/nshop";

function formatter_account(value) {
    if (typeof value !== "string") return value || "-";

    let index = value.indexOf("(");

    if (index < 0) return value || "-";
    if (value[index - 1] !== " ") return value || "-";

    return value.slice(0, index - 1) + "\n" + value.slice(index);
}

function getExpiresAt(date, returnsDayjs = false) {
    let expiresAt = dayjs.tz(date);
    expiresAt = expiresAt.endOf("day");
    expiresAt = expiresAt.subtract(40, "minutes");
    if (returnsDayjs) return expiresAt;
    return expiresAt.format("YYYY년 MM월 DD일 HH시 mm분 ss초");
}

export default {
    props: {
        /** @type {import('vue').PropType<import('@/store/nshop').NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    data: () => ({}),
    computed: {
        shows() {
            return this.value?.payment?.method === "vaccount";
        },

        /** @returns {import('@/store/nshop').NshopOrder[]} */
        items() {
            return [this.value];
        },

        headers() {
            let isStopped = this.value.state === "ORDER_STOP";

            /** @type {import('@/assets/lib').Header[]} */
            let headers = [
                {
                    text: "주문상태",
                    value: "state",
                    formatter: (value) => NSHOP_ORDER_STATES[value]?.text || "-",
                },
                {
                    text: "결제수단",
                    value: "payment.method",
                    formatter: (value) => NSHOP_ORDER_PAYMENT_METHODS[value]?.text || "-",
                },
            ];

            switch (this.value?.payment?.method) {
                case "vaccount": {
                    headers.push(
                        {
                            text: "출금계좌",
                            value: "payment.vaccount.waccount",
                            class: isStopped ? "text-decoration-line-through" : undefined,
                            formatter: formatter_account,
                        },

                        {
                            text: "입금계좌",
                            value: "payment.vaccount.vaccount",
                            class: isStopped ? "text-decoration-line-through" : undefined,
                            formatter: formatter_account,
                        },

                        {
                            text: "입금금액",
                            value: "price.sale",
                            class: isStopped ? "text-decoration-line-through" : undefined,
                            formatterType: "number",
                            formatterSuffix: "원",
                        },

                        {
                            text: "입금기한",
                            value: "createdAt",
                            formatterType: "datetime",
                            class: isStopped ? "text-decoration-line-through" : undefined,
                            formatter: (value) => getExpiresAt(value),
                        },

                        {
                            text: "입금상태",
                            value: "_payment",
                            formatterType: "datetime",
                            class: isStopped ? "text-decoration-line-through" : undefined,
                            formatter: (value, item) => {
                                if (!!value) return "입금완료";

                                let expiresAt = getExpiresAt(item.createdAt, true);
                                if (dayjs.tz().isBefore(expiresAt)) return "입금대기";

                                return "입금만료";
                            },
                        },
                    );
                    break;
                }
            }

            if (isStopped) {
                headers.push({
                    text: "주문취소일시",
                    value: "stoppedAt",
                    formatterType: "datetime",
                });
            }

            return initDataTableHeaders(headers);
        },
    },
};
</script>

<style lang="scss" scoped>
.nshop-order-view-table {
    &,
    ::v-deep *,
    ::v-deep td {
        font-size: 14px !important;
        line-height: 1.25 !important;
    }

    ::v-deep colgroup {
        display: none;
    }
    ::v-deep table {
        border-bottom: none !important;
    }
    ::v-deep .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>
